import moment from 'moment';
import { naturalNumber } from '@components/eth/Utils';
import { dappStore } from '@components/store';
import { Position } from 'types';
import React from 'react';
import styled from 'styled-components';
import { useGetPositionLifetimeInDays } from '@components/store/getters';
import { TableWrapper, ActionsWrap } from './Table.styles';
import PositionTableHead from './PositionTableHead';
import Button from '@components/common/Button';

interface TableProps {
  openPositions: Position[];
}

const StyledDataCell = styled.td<{ expiringSoon?: boolean }>`
  ${({
    expiringSoon,
    theme: {
      colors: {
        secondary: { red },
      },
    },
  }) =>
    expiringSoon &&
    `
    color: ${red};
    font-weight: 700;
  `}
`;

export default function Table({ openPositions }: TableProps) {
  const positionLifetimeInDays = useGetPositionLifetimeInDays();
  // Before we show the modal, we need to load the correct data
  function closePosition(nftId: number) {
    const activePosition = openPositions.find((position) => position.nftId === nftId);
    dappStore.setState({ activePositionId: nftId, activePosition, isClosePositionModal: true });
  }
  function viewDetails(nftId: number) {
    // console.log('called viewDetails');
    const activePosition = openPositions.find((position) => position.nftId === nftId);
    dappStore.setState({ activePositionId: nftId, isViewNft: true, activePosition });
  }

  // Todo: refactor table
  return (
    <TableWrapper>
      <section>
        <table>
          <PositionTableHead />
          {(!openPositions || openPositions.length === 0) && (
            <tbody>
              <tr>
                <td colSpan={7}>
                  <p>We don&apos;t see any open positions associated with your wallet.</p>
                </td>
              </tr>
            </tbody>
          )}
          {openPositions.length > 0 && (
            <tbody>
              {openPositions.map((position) => (
                <tr key={position.nftId}>
                  <td>{moment.unix(position.unixTimestampOpened).format('MMM DD, YYYY')}</td>
                  {/* <td>{position.apy > 0 ? naturalNumber(position.apy.toString()) + '%' : '--'}</td> */}
                  <td>{naturalNumber(position.collateral)} OUSD</td>
                  <td>{naturalNumber(position.ousdBorrowed)} OUSD</td>
                  <td>{naturalNumber(position.ousdTotalWithoutInterest)} OUSD</td>
                  <td>
                    {parseFloat(naturalNumber(position.totalInterestEarned)) > 0
                      ? naturalNumber(position.totalInterestEarned) + ' OUSD'
                      : '--'}
                  </td>
                  <StyledDataCell expiringSoon={position.lifetimeInDays < 8}>
                    {moment.unix(position.unixTimestampOpened + position.lifetimeInDays * 86400).format('MMM DD, YYYY')}
                  </StyledDataCell>
                  <td>
                    <ActionsWrap>
                      <Button variant="thick" onClick={() => viewDetails(position.nftId)}>
                        Details
                      </Button>
                      <Button variant="thick" onClick={() => closePosition(position.nftId)}>
                        Close
                      </Button>
                    </ActionsWrap>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </section>
    </TableWrapper>
  );
}
